import TableCell from "@mui/material/TableCell";
import { GenericInput } from "@asez/component-library";
import { TEXT_ALIGN } from "@asez/shared";
import { middleCellSx } from "./tableStyles";

interface InputCellProps {
  type: string;
  value: string;
  className?: string;
  textAlign?: TEXT_ALIGN;
  onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputCell = ({
  type,
  value,
  onChangeHandler,
  className = "",
  textAlign = TEXT_ALIGN.left,
}: InputCellProps) => {
  return (
    <TableCell
      align="center"
      sx={{
        ...middleCellSx,
        borderRight: 1,
        borderColor: "var(--color-table-header)",
      }}
    >
      <GenericInput
        className={className}
        type={type}
        value={value}
        onChange={onChangeHandler}
        textAlign={textAlign}
        sx={{
          "& .MuiInputBase-input": {
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
      />
    </TableCell>
  );
};

export default InputCell;
